import { useEffect, useState } from 'react';

import { motion } from 'framer-motion';
import { BadgePercent } from 'lucide-react';

const getRandomPosition = () => ({
	top: `${Math.random() * 100}%`,
	left: `${Math.random() * 100}%`,
});

export default function FlyingIcons() {
	const [icons, setIcons] = useState<
		{ id: number; position: { top: string; left: string }; size: number }[]
	>([]);

	useEffect(() => {
		const interval = setInterval(() => {
			const id = Date.now();
			const position = getRandomPosition();
			const size = Math.floor(Math.random() * 100) + 24;

			setIcons((prev) => [...prev, { id, position, size }]);

			setTimeout(() => {
				setIcons((prev) => prev.filter((icon) => icon.id !== id));
			}, 3000);
		}, 800);

		return () => clearInterval(interval);
	}, []);

	return (
		<>
			{icons.map((icon) => (
				<motion.div
					key={icon.id}
					initial={{ opacity: 0, scale: 0 }}
					animate={{ opacity: 1, scale: [1, 1.2, 1] }}
					transition={{ duration: 0.6, ease: 'easeInOut' }}
					style={{
						position: 'absolute',
						top: icon.position.top,
						left: icon.position.left,
						zIndex: 0,
					}}
				>
					<BadgePercent
						size={icon.size}
						className="text-secondary drop-shadow-lg"
					/>
				</motion.div>
			))}
		</>
	);
}
